/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable new-cap */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, subDays } from 'date-fns'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { BarraTitulo } from '../../components/BarraTitulo'
import { api } from '../../services/api'
import Loading from './components/Loanding/index'
import { useParams } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'
import { useContext } from 'react'
import MyContext from '../../contexts/myContext'
import styles from "./styles.module.css"
import "../../components/stylesGuia.css"
import { GridRegistros } from './components/GridRegistros'



export default function B2B_MovimentacoesFiscais(props) {
    const [RegistrosNFSaida, setRegistrosNFSaida] = useState([])
    const [RegistrosEntradaMercadorias, setRegistrosEntradaMercadorias] = useState([])
    const [RegistrosFaturas, setRegistrosFaturas] = useState([])
    const [RegistrosFinanceiro, setRegistrosFinanceiro] = useState([])
    const [isLoading, setisLoading] = useState(false)

    const params = useParams()
    const vNomeAmigavel = params.NomeAmigavel || props.NomeAmigavel

    const { setHidebar, user, hideBar } = useContext(MyContext)

    useEffect(() => {

        if (params?.hideBar === "true") {
            setHidebar(true)
        }

    }, [])

    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    function DataFilter() {
        let vDataInicial = window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value
        let vDataFinal = window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value

        if (vDataInicial.length !== 0 && vDataFinal.length === 0) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'Preencha a data final!'
            })
        }
        if (vDataInicial.length === 0 && vDataFinal.length !== 0) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'Preencha a data Inicial!'
            })
        }
        if (vDataInicial > vDataFinal) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'A data inicial não pode ser maior que a data final!'
            })
        }

        getRegistrosBD()
    }

    const getRegistrosBD = async () => {

        let vDataInicial = window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value
        let vDataFinal = window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value

        setisLoading(true)

        setRegistrosEntradaMercadorias([]);
        setRegistrosFaturas([]);
        setRegistrosFinanceiro([]);
        setRegistrosNFSaida([]);

        const myDadosDash = dadosDash.filter(dash => dash.NomeAmigavel === vNomeAmigavel)

        if (myDadosDash.length > 0) {
            await api
                .get('/B2B_MovimentacoesFiscais/api/RegistrosNFSaida',
                    {
                        params: {
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data
                    setRegistrosNFSaida(results)
                })
                .catch(error => console.log(error))

            await api
                .get('/B2B_MovimentacoesFiscais/api/RegistrosEntradaMercadorias',
                    {
                        params: {
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data
                    setRegistrosEntradaMercadorias(results)
                })
                .catch(error => console.log(error))

            await api
                .get('/B2B_MovimentacoesFiscais/api/RegistrosFaturas',
                    {
                        params: {
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data
                    setRegistrosFaturas(results)
                })
                .catch(error => console.log(error))

            await api
                .get('/B2B_MovimentacoesFiscais/api/RegistrosFinanceiro',
                    {
                        params: {
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data
                    setRegistrosFinanceiro(results)
                })
                .catch(error => console.log(error))
        }

        setisLoading(false)
    }

    const printRefPage = React.useRef()


    const handleDownloadPdfPage = async () => {
        const element = printRefPage.current
        const canvas = await html2canvas(element)
        const data = canvas.toDataURL('image/png')

        const pdf = new jsPDF()
        const imgProperties = pdf.getImageProperties(data)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight =
            1000

        pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight)
        pdf.save('B2bMovFiscais.pdf')
    }

    function ExportarComponentePage() {
        Swal.fire({
            title: 'Como deseja exportar o Componente?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Imagem',
            denyButtonText: 'PDF',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.fire('Imagem exportada!', '', 'success')
                // Função para imagem
                // exportComponentAsPNG(printRef)
                const { exportComponentAsPNG } = await import('react-component-export-image')
                exportComponentAsPNG(printRefPage)
            } else if (result.isDenied) {
                // Função para PDF
                Swal.fire('PDF exportado!', '', 'success')
                handleDownloadPdfPage()
            }
        })
    }



    const [dadosDash, setDadosDash] = useState([])
    const [minutosTempoAtualizacao, setMinutosTempoAtualizacao] = useState(0)
    const [opPeriodoInicialPesquisa, setOpPeriodoInicialPesquisa] = useState('NÃO ESPECIFICADO')
    const [diasPeriodoInicial, setDiasPeriodoInicial] = useState(0)

    const getDadosDashBoard = async () => {
        await api
            .get('/dashboard/api/listaDashboard')
            .then(data => {
                setDadosDash(data.data)
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        getDadosDashBoard()
    }, [])

    useEffect(async () => {
        if (dadosDash.length > 0) {

            const myDadosDash = dadosDash.filter(dash => dash.NomeAmigavel === vNomeAmigavel)
            if (myDadosDash.length > 0) {
                setMinutosTempoAtualizacao(parseInt(myDadosDash[0].minutosTempoAtualizacao))

                const vOpPeriodoInicialPesquisa = myDadosDash[0].opPeriodoInicialPesquisa
                setOpPeriodoInicialPesquisa(vOpPeriodoInicialPesquisa)

                const vDiasPeriodoInicial = parseInt(myDadosDash[0].diasPeriodoInicial)
                setDiasPeriodoInicial(vDiasPeriodoInicial)

                switch (vOpPeriodoInicialPesquisa) {
                    case 'ESPECIFICADO':

                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(subDays(today, vDiasPeriodoInicial)), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(today, 'yyyy-MM-dd')
                        break

                    case 'DIA ATUAL':
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(today, 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(today, 'yyyy-MM-dd')
                        break
                    case 'SEMANA ATUAL':
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(startOfWeek(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(new Date(endOfWeek(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'MÊS ATUAL':
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(startOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(new Date(endOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'TRIMESTRE ATUAL':
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(startOfQuarter(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(new Date(endOfQuarter(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'ANO ATUAL':
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(startOfYear(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(new Date(endOfYear(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    default:
                        //DEFAULT = MÊS ATUAL
                        window.document.getElementById('dtIniB2B_MovimentacoesFiscais').value = format(new Date(startOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimB2B_MovimentacoesFiscais').value = format(new Date(endOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                }
                getRegistrosBD()
            }
        }
    }, [dadosDash])

    useEffect(() => {

        if (parseInt(minutosTempoAtualizacao) > 0) {
            const interval = setInterval(() => {
                getRegistrosBD()
            }, parseInt(minutosTempoAtualizacao) * 60000);

            return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
        }
    }, [minutosTempoAtualizacao])


    return (
        <div className='flex flex-col bg-gray-100 h-full w-full  overflow-x-hidden'>
            {isLoading && <Loading />}
            <BarraTitulo
                Name={vNomeAmigavel}
                showTasks={true}
                new={false}
                search={false}
                save={false}
                clean={false}
                delete={false}
                printer={true}
                ExportarPage={() => ExportarComponentePage()}
            />
            <section ref={printRefPage} className={`flex flex-col overflow-y-scroll overflow-x-hidden ${hideBar ? '!h-fit' : '!h-[75vh]'} pb-4  `}>
                { /* 
                <section ref={printRefPage} className={`bg-gray-100 h-full  flex flex-col overflow-y-scroll overflow-x-hidden ${!hideBar && 'div-scroll-hidden'}`}>
                */}
                <div className={` flex flex-row  ${styles.containerFiltros} `} >
                    <div className='mt-2 mb-2 px-6'>

                        <div className={`bg-white-100 w-fit  flex flex-row items-center gap-x-2  h-full rounded-md`}>

                            <div className={` ${styles.containerDatas} flex gap-x-2 items-center ml-2 p-4 `}>

                                <div className={` ${styles.containerFiltroDatas}`}>
                                    <div className={` ${styles.divInputDatas} flex flex-row items-center justify-center gap-2 mt-2 `} >
                                        <div className='flex gap-x-2 items-center justify-center'>
                                            <label className='text-sm'>
                                                De:
                                            </label>
                                            <input className='w-36 border-2 border-gray-400 rounded-lg text-sm' id="dtIniB2B_MovimentacoesFiscais" type="date" maxLength="10" />
                                        </div>

                                        <div className='flex gap-x-2 items-center justify-center'>
                                            <label className='text-sm'>
                                                Até:
                                            </label>
                                            <input className='w-36 text-sm border-2 border-gray-400 rounded-lg' id="dtFimB2B_MovimentacoesFiscais" type="date" maxLength="10" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <button onClick={() => { DataFilter() }} id="submit" className='text-white-100 h-full text-center text-base font-bold rounded-r-lg p-2 bg-gradient-to-r from-slate-900 to-slate-700'>
                                <FeatherIcon icon={'search'} />
                            </button>
                        </div>
                    </div>
                </div>

                <div className='mt-1 pb-4 '>
                    <div className="mt-1 pl-6 pr-6  flex flex-col ">
                        <div className="mt-2">
                            <GridRegistros
                                RegistrosBDFiltro={RegistrosNFSaida}
                                Titulo="NF-E DE SAÍDA"
                            />
                            <GridRegistros
                                RegistrosBDFiltro={RegistrosEntradaMercadorias}
                                Titulo="ENTRADA DE MERCADORIAS"
                            />

                            <GridRegistros
                                RegistrosBDFiltro={RegistrosFaturas}
                                Titulo="FATURAS"
                            />
                            <GridRegistros
                                RegistrosBDFiltro={RegistrosFinanceiro}
                                Titulo="FINANCEIRO"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
